import type { GetMemberQueryParams } from '@gonfalon/openapi/operations/getMember';

import { createQueryFetcher } from '../internal/createQueryFetcher';
import { getMemberQuery } from '../queries/members';

export const fetchMember = createQueryFetcher(
  ({ memberId, params }: { memberId: string; params?: GetMemberQueryParams }) =>
    getMemberQuery({ id: memberId, query: params }),
);
